/* Makers Art Studio — primary navigation behaviour.

   The markup is rendered by sections/mas-header.liquid from a Shopify navigation
   menu. This file used to BUILD that markup in the browser, which left the whole
   navigation invisible to crawlers and made Shopify's Navigation settings inert
   (issue #128). It now only wires up interaction, so the menu exists in the HTML
   whether or not this script runs. */
(function () {
  const root = document.getElementById('site-menu');
  if (!root) return;

  // ── panels ──
  const items = [...root.querySelectorAll('.mm-item')];
  let openItem = null;
  function close(it) {
    if (!it) return;
    it.classList.remove('open');
    it.querySelector('.mm-top').setAttribute('aria-expanded', 'false');
    if (openItem === it) openItem = null;
  }
  function open(it) {
    if (openItem && openItem !== it) close(openItem);
    it.classList.add('open');
    it.querySelector('.mm-top').setAttribute('aria-expanded', 'true');
    openItem = it;
  }
  items.forEach((it) => {
    const btn = it.querySelector('.mm-top');
    if (!btn) return;
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      it.classList.contains('open') ? close(it) : open(it);
    });
    // hover open on desktop (pointer); close is DELAYED so the cursor can
    // cross the 12px gap between trigger and panel without dismissing it
    it.addEventListener('mouseenter', () => {
      if (!window.matchMedia('(min-width:981px)').matches) return;
      clearTimeout(it._closeTimer);
      open(it);
    });
    it.addEventListener('mouseleave', () => {
      if (!window.matchMedia('(min-width:981px)').matches) return;
      clearTimeout(it._closeTimer);
      it._closeTimer = setTimeout(() => close(it), 220);
    });
  });
  document.addEventListener('click', (e) => { if (!root.contains(e.target)) close(openItem); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(openItem); });
  // close panel when a link inside is clicked (in-page anchors)
  root.querySelectorAll('.mm-panel a').forEach((a) => a.addEventListener('click', () => close(openItem)));

  // ── mobile ──
  const burger = root.querySelector('.mm-burger');
  if (burger) {
    burger.addEventListener('click', () => {
      const on = root.classList.toggle('mobile-open');
      burger.setAttribute('aria-expanded', on);
    });
  }

  // Book Now: if THIS page has the experiences grid, smooth-scroll to it; otherwise
  // let the anchor navigate to the destination set in the theme editor. The anchor
  // always carries a real href, so the button works with JavaScript disabled too.
  const bookBtn = root.querySelector('.mm-book');
  if (bookBtn) {
    bookBtn.addEventListener('click', (e) => {
      const target = document.getElementById('experiences');
      if (!target) return;
      e.preventDefault();
      root.classList.remove('mobile-open');
      if (burger) burger.setAttribute('aria-expanded', 'false');
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }
})();
